module.exports = __webpack_public_path__ + "img/youIcon.fe2218c0.png";